$(function () {
    var body = $('body');
    var nav = $('.nav');
    var burger = $('.burger');
    var first_link = $('.nav').find('> ul > li.menu-item:first-child > a, > ul > li.menu-item:first-child > button')
    var parent_link = $('.nav').find('> ul > li.menu-item > a, > ul > li.menu-item > button');
    var nav_trigger = $('.nav').find('ul li.menu-item-has-children button, ul li.menu-item-has-children a');
    var megamenu_trigger = $('.nav').find('ul li.menu-item-has-megamenu .menu-item-has-megamenu-button>button, ul li.menu-item-has-megamenu .menu-item-has-megamenu-button>a');
    var megamenu_child_trigger = $('.nav').find('ul li.menu-item-has-megamenu a.megamenu-link-has-children');
    var nav_align = 'right';
    var break_point = 1200;
    var browser_width = window.innerWidth;
    var nav_width = 300;
    var nav_window = $('<div class="navwindow"></div>');
    body.append(nav_window);
    var nav_wrap = $('.navwrap');

    var searchToggle = $('.searchToggleTrigger');
    var searchbarClose = $('.searchbarClose');
    var searchBar = $('.searchBarElement');
    var searchBarFocusElement = $('.searchBarFocus');
    var wrapper = $('.wrapper');
    var searchBarHidden = true;

    document.addEventListener('keydown', function (event) {
        const key = event.key;
        if (key === "Escape") {
            if (browser_width < break_point) {
                nav_reset();
                burger.focus();
                nav.find('a, button').attr('tabindex', '-1');
            } else {
                $('.menu-item-has-children').removeClass('__active');
                $('.menu-item-has-megamenu').removeClass('__active');
                $('.menu-item-has-megamenu button').attr('aria-expanded', false);
            }
        }
    });

    // set tabindex for menu links if user zooms in to 200%
    window.addEventListener("resize", function () {
        browser_width = window.innerWidth;  // Ensure updated browser width

        if ((window.devicePixelRatio >= 1.25 && browser_width < break_point) ||
            (window.devicePixelRatio >= 2 && browser_width >= break_point)) {
            body.addClass('__zoom-accessibility');
            parent_link.attr('tabindex', '-1');
            initMenu();
        }

        else {
            body.removeClass('__zoom-accessibility');
            parent_link.attr('tabindex', '0');
            initMenu();
        }
    });

    var search_launch = function search_launch() {
        searchBarHidden = false;
        searchBar.attr('aria-hidden', searchBarHidden);
        searchToggle.toggleClass('__active');
        searchBar.find('*[tabindex=-1]').removeAttr('tabindex');
        searchBar.slideDown();
        searchBarFocusElement.focus();
    }

    var search_reset = function search_reset() {
        searchBarHidden = true;
        searchBar.attr('aria-hidden', searchBarHidden);
        searchToggle.toggleClass('__active');
        searchBar.find('*[tabindex=0]').attr('tabindex', '-1');
        searchBar.slideUp();
        searchToggle.focus();
    }

    searchToggle.click(function (event) {
        event.preventDefault();
        if (searchBarHidden) {
            search_launch();
        } else {
            search_reset();
        }
        if (browser_width < break_point) {
            if (burger.hasClass('__active')) {
                nav_reset();
                nav.find('a, button').attr('tabindex', '-1');
            }
        }
    });

    searchbarClose.click(function (event) {
        event.preventDefault();
        search_reset();
        
        if (browser_width < break_point) {
            if (burger.hasClass('__active')) {
                nav_reset();
                nav.find('a, button').attr('tabindex', '-1');
            }
        }
    });

    nav_window.click(function (event) {
        nav_reset();
        nav.find('a, button').attr('tabindex', '-1');
    });

    //burger click
    burger.click(function (event) {
        event.preventDefault();
        if ($(this).hasClass('__active')) {
            $(this).removeClass('__active');
            nav_reset();
            nav.find('a, button').attr('tabindex', '-1');
            $(this).focus();
        } else {
            $(this).addClass('__active');
            nav_launch();
            first_link.focus();
        }
        if (searchToggle.hasClass('__active')) {
            searchBarHidden = !searchBarHidden;
            search_reset();
        }
    });

    first_link.on('keydown', function (event) {
        if (event.key === 'Tab' && event.shiftKey) {
            event.preventDefault();
            burger.focus(); 
        }
    });

    /*nav reset*/
    var nav_reset = function nav_reset() {
        burger.removeClass('__active');
        nav_window.hide();
        body.removeClass('__mobile');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul, div').removeClass('__active');
    };

    /*nav launch*/
    var nav_launch = function nav_launch() {
        nav_window.show();
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
        nav.find('a, button').removeAttr('tabindex');
        nav.find('a, button')[0].focus();
    };

    function initMenu() {
        browser_width = window.innerWidth;  // Update browser width

        $(".navwrap ul").on("mouseenter focusin", function () {
            $('.navwrap ul').each(function () {
                var elem = $(this)
                var rect = elem[0].getBoundingClientRect();
                if (rect.x + rect.width > window.innerWidth) {
                    $(this).addClass('left');
                }
            });
        });

        // nav dropdown on focus/keyboard navigation
        if (browser_width >= break_point && !body.hasClass('__zoom-accessibility')) {
            nav.find('a, button').attr('tabindex', '0');

            nav_trigger.click(function (event) {
                if($(this).is('button')) {
                    event.preventDefault();
                    $(this).parent().siblings().removeClass('__active');
                    $(this).parent().siblings().find('.__active').removeClass('__active');
                    $(this).parent().siblings().find('[aria-expanded="true"]').attr('aria-expanded', false);
                    $(this).parent().toggleClass('__active');
                    if($(this).parent().hasClass( '__active' )) {
                        $(this).attr('aria-expanded', true);
                    } else {
                        $(this).attr('aria-expanded', false);
                        $(this).parent().find('.__active').removeClass('__active');
                    }
                }
            });
            
            $(document).on("click", function (event) {
                if ($(event.target).closest(".nav[aria-label='Primary']").length === 0) {
                    nav.find('.__active').removeClass('__active');
                    nav.find('[aria-expanded="true"]').attr('aria-expanded', false);
                }
            });

            megamenu_trigger.click(function (event) {
                if($(this).is('button')) {
                    event.preventDefault();
                    $(this).parent().parent().siblings().removeClass('__active');
                    $(this).parent().parent().siblings().find('.__active').removeClass('__active');
                    $(this).parent().parent().siblings().find('[aria-expanded="true"]').attr('aria-expanded', false);
                    $(this).parent().parent().toggleClass('__active');
                    if($(this).parent().parent().hasClass( '__active' )) {
                        $(this).attr('aria-expanded', true);
                    } else {
                        $(this).attr('aria-expanded', false);
                        $(this).parent().parent().find('.__active').removeClass('__active');
                    }
                }
            });
            
            
        }

        if (browser_width < break_point) {
            nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).parent().children('ul').length > 0) {
                    $(this)
                        .parent().children('ul')
                        .addClass('__active');
                    $(this)
                        .parent().children('ul').find('li:first-child a, li:first-child button').focus();
                }
            });

            megamenu_trigger.click(function (event) {
                event.stopPropagation();

                $(this)
                    .parent().parent()
                    .toggleClass('__active');
                $(this)
                    .parent().parent()
                    .children('.menu-item-is-megamenu')
                    .toggleClass('__active');
            });

            megamenu_child_trigger.click(function (event) {
                $(this)
                    .toggleClass('__active');
                $(this)
                    .siblings('.megamenu-list')
                    .toggleClass('__active');
            });

            // Disable root item link click
            $('.menu-item-has-children > a, .menu-item-has-megamenu .menu-item-has-megamenu-button> a, a.megamenu-link-has-children').click(function (event) {
                event.preventDefault();
            });

        }

        if (browser_width < break_point) {
            nav.find('a, button').attr('tabindex', '-1');
            var back_menu = $('.backto');
            back_menu.click(function (event) {
                event.preventDefault();
                event.stopPropagation();
                $(this)
                    .parent('ul, .menu-item-is-megamenu')
                    .removeClass('__active');
                $(this)
                    .parents('li')
                    .parent('ul')
                    .addClass('__active');
                $(this)
                    .parents('li').children('a').focus();
            });
        }

        // Touch device check
        const isTouchDevice = () => {
            return window.matchMedia("(pointer: coarse)").matches
        }
        // If desktop and touch device, disable link click and add extra view link
        if (browser_width > break_point && isTouchDevice()) {
            nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).children('ul').length > 0) {
                    event.preventDefault();
                }
            });
        }

        var view_all = $('.viewall');
        view_all.click(function (event) {
            event.stopPropagation();
        });

        var back_menu = $('.backto button');
        back_menu.click(function (event) {
            event.preventDefault();
            event.stopPropagation();
            // $(this).closest('.menu-item-has-megamenu').removeClass('__active');
            $(this).closest('.__active').removeClass('__active');
        });
    }

    initMenu();

    $(window).on('resize', function () {
        nav_reset()
        initMenu();
    });
});